import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import { addProduct } from 'redux/actions/productActions';
import { useTranslation } from 'react-i18next';
import { ADMIN_PRODUCTS } from 'constants/routes';

const ProductForm = lazy(() => import('components/product/ProductForm'));

const AddProduct = () => {
  const { t } = useTranslation();
  const history = useHistory();
  useScrollTop();
  useDocumentTitle(`${t('titleAddProduct')} - Uilpi`);
  const isLoading = useSelector((state) => state.app.loading);
  const dispatch = useDispatch();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const onSubmit = (product) => {
    dispatch(addProduct(product));
  };

  return (
    <div className="product-form-container">
      <h2>{t('titleAddProduct')}</h2>
      <Suspense
        fallback={
          <div className="loader" style={{ minHeight: '80vh' }}>
            <h6>{t('loadingMessage')}</h6>
            <br />
            <LoadingOutlined />
          </div>
        }
      >
        <ProductForm
          isLoading={isLoading}
          onSubmit={onSubmit}
          isAdmin
          isNew
          product={{
            name: '',
            price: 0,
            description: '',
            keywords: [],
            image: '',
            sold: false,
            featured: false,
            visible: false,
            imageCollection: [],
            category: {
              type: 'Bicicletta',
              sub1: 'Strada',
              sub2: 'Corsa',
              assisted: 'Non Assistita',
              year: new Date().getFullYear(),
              size: 'M',
              weight: 8,
              wheels: 20,
              brand: 'Non Specificata'
            },
            address: {
              country: 'Italia',
              municipality: 'Milano',
              province: 'Milano',
              region: 'Lombardia',
              npa: '1000'
            }
          }}
        />
      </Suspense>
      <br />
      <button
        className="button button-muted w-100-mobile"
        disabled={isLoading}
        onClick={() => history.push(ADMIN_PRODUCTS)}
        type="button"
      >
        <ArrowLeftOutlined />
        &nbsp; {t('errorButtonBack')}
      </button>
    </div>
  );
};

export default withRouter(AddProduct);
